
export default function MetaTitle(props) {
	return <title> {props.children} | Sun Plugged Energy</title>
}